import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QUIZ_QUESTION_FEATURE_KEY } from './keys';
import { quizQuestionReducer } from './reducers/quiz-question.reducer';
import { QuizQuestionEffects } from './effects/quiz-question.effects';

export function provideQuizQuestionStore(): EnvironmentProviders[] {
    return [provideState(QUIZ_QUESTION_FEATURE_KEY, quizQuestionReducer), provideEffects(QuizQuestionEffects)];
}
